import { Component, Input, OnChanges, OnDestroy, SimpleChanges, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { PrintingStatusReason } from '@shared/constants/status-reason';
import { statusTypes } from '@shared/constants/status-types';
import { IDeviceJob } from '@shared/interfaces/device/device-job';
import { IDeviceStatus } from '@shared/interfaces/device/device-status';
import { DeviceStatusService } from '@shared/modules/device/services/device-status.service';
import { interval, Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-device-progressbar',
  templateUrl: './device-progressbar.component.html',
  styleUrls: ['./device-progressbar.component.scss']
})
export class DeviceProgressbarComponent implements OnDestroy, OnChanges {
  @Input() deviceJob!: IDeviceJob | undefined;
  @Input() deviceStatus!: IDeviceStatus

  displayTime = 0;
  statusTypes = statusTypes;
  printingReason = PrintingStatusReason;

  private intervalSubscription: Subscription | null = null;

  constructor(
    private statusService: DeviceStatusService
  ) { }

  protected get isCompleted(): boolean {
    return this.statusService.checkReason(this.deviceStatus, statusTypes.printing, PrintingStatusReason.COMPLETED);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.deviceStatus.statusCode === statusTypes.printing && this.deviceJob && changes["deviceJob"]) {
      this.displayTime = this.deviceJob.leftTime;
      
      //this.intervalSubscription ?? this.initInterval();
    }

    if (this.deviceStatus.statusCode !== statusTypes.printing) {
      this.intervalSubscription?.unsubscribe();
    }

    if (changes["deviceStatus"] &&
      changes["deviceStatus"].previousValue &&
      changes["deviceStatus"].previousValue.statusCode !== statusTypes.printing &&
      changes["deviceStatus"].currentValue &&
      changes["deviceStatus"].currentValue.statusCode === statusTypes.printing) {
      //this.initInterval();
    }
  }

  initInterval() {
    this.intervalSubscription = interval(1000)
      .pipe(tap(() => {
        if (this.deviceJob) {
          if (Math.abs(this.deviceJob.leftTime - this.displayTime) > 30) this.displayTime = this.deviceJob.leftTime;
          this.displayTime = this.countdown(this.displayTime);
        }
      })).subscribe();
  }

  ngOnDestroy() {
    this.intervalSubscription?.unsubscribe();
  }

  countdown(seconds: number): number {
    if (seconds <= 0) return seconds;
    return --seconds;
  }
}
